module.exports = __webpack_public_path__ + "img/bottom_sensor_alert.e66d9305.svg";